import { useEffect, useState } from 'react';

import { Navigate, useNavigate } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT } from '#client/build-env';
import { OrphanAccountRedirect } from '#client/components/OrphanAccountRedirect';
import { SHOW_ORPHAN_ACCOUNT_OPTIONS } from '#client/constants/experimentsFlags';
import * as ROUTES from '#client/constants/routes';

export default function Landing() {
  const { authenticated, login } = useAuthentication();
  const { loading: entityLoading, businessEntityUuid } = useBusinessEntity();
  const enableVeloRedirectOptions = useExperimentFlag(SHOW_ORPHAN_ACCOUNT_OPTIONS, false);
  const [shouldRedirectOrphanAccount, setShouldRedirectOrphanAccount] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      login(`${DEFAULT_SEGMENT}/`);
      return;
    }
    if (!entityLoading && businessEntityUuid) {
      navigate(`${DEFAULT_SEGMENT}/${businessEntityUuid}/`);
    }

    // Check for orphan account redirect if no business entity
    if (!entityLoading && !businessEntityUuid) {
      setShouldRedirectOrphanAccount(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, entityLoading, businessEntityUuid]);

  // Navigate to get-started page or show OrphanAccountRedirect based on feature flag
  if (shouldRedirectOrphanAccount && enableVeloRedirectOptions) {
    return <Navigate to={ROUTES.getStarted} replace />;
  }

  if (shouldRedirectOrphanAccount && !enableVeloRedirectOptions) {
    return <OrphanAccountRedirect />;
  }

  return <PageLoading />;
}
